export function buildFreeToolPrimaryCta(frontendUrl, tool, primaryHref) {
    const href = primaryHref || `${frontendUrl}/register`;
    const url = new URL(href, frontendUrl);
    const pathname = url.pathname.replace(/\/+$/, '');
    url.searchParams.set('utm_source', 'free_tool');
    url.searchParams.set('utm_content', tool || 'free_tool');

    return {
        href: href.startsWith('/') && !href.startsWith('//')
            ? `${url.pathname}${url.search}${url.hash}`
            : url.href,
        target: pathname === '/pricing' ? 'pricing' : pathname === '/register' ? 'register' : 'link'
    };
}

export function getPricingRegisterHref(frontendUrl, {pathname, search}) {
    const params = new URLSearchParams(search);
    if (pathname.replace(/\/+$/, '') !== '/pricing' || params.get('utm_source') !== 'free_tool') {
        return `${frontendUrl}/register`;
    }

    return buildFreeToolPrimaryCta(frontendUrl, params.get('utm_content')).href;
}
